import updateDistance from 'reducers/updateDistance'

export default ({ camera, multiplier }) => {
  const distance = camera.distance * multiplier
  const cameraHeight = camera.cameraHeight * multiplier
  const sceneHeight = camera.sceneHeight * multiplier

  const updatedCamera = Object.assign({}, camera, {
    distance, cameraHeight, sceneHeight
  })
  return updateDistance(updatedCamera, String(distance))
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/changeCameraUnit.js